import { FormQuestion } from '@models/membership/Form'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_FORM_QUESTIONS_URL } from '@utils/urls'

const fetchFormQuestions = (params: TableParams) =>
  SBAPI.FetchPaginated<FormQuestion[]>(MEMBERSHIP_FORM_QUESTIONS_URL, params)

const createFormQuestion = (data: FormData) =>
  SBAPI.Post(MEMBERSHIP_FORM_QUESTIONS_URL, data)

const updateFormQuestion = (data: FormData) =>
  SBAPI.Post(`${MEMBERSHIP_FORM_QUESTIONS_URL}/${data.get('id')}`, data)

const deleteFormQuestion = (id: number) =>
  SBAPI.Delete(`${MEMBERSHIP_FORM_QUESTIONS_URL}/${id}`)

export {
  createFormQuestion,
  deleteFormQuestion,
  fetchFormQuestions,
  updateFormQuestion,
}
